import { Input, Label } from '@hqo/ui-atoms';
import { useIntl } from 'react-intl';

interface TimeModeSelectorProps {
  value: 'duration' | 'endTime';
  onDurationChange: () => void;
  onEndTimeChange: () => void;
  required?: boolean;
}

export const TimeModeSelector = ({
  value,
  onDurationChange,
  onEndTimeChange,
  required = false,
}: TimeModeSelectorProps): JSX.Element => {
  const { formatMessage } = useIntl();

  return (
    <div className="flex items-center gap-6">
      <Label className="flex cursor-pointer items-center gap-2">
        <Input
          type="radio"
          name="timeMode"
          value="duration"
          checked={value === 'duration'}
          onChange={onDurationChange}
          className="h-5 w-5 cursor-pointer text-primary focus:ring-primary"
        />
        <span className="text-sm font-medium text-gray-900">
          {formatMessage({
            id: 'createVisitFormV2.whenStep.duration',
            defaultMessage: 'Duration',
          })}
          {required && value === 'duration' && <span className="text-destructive ml-1">*</span>}
        </span>
      </Label>
      <Label className="flex cursor-pointer items-center gap-2">
        <Input
          type="radio"
          name="timeMode"
          value="endTime"
          checked={value === 'endTime'}
          onChange={onEndTimeChange}
          className="h-5 w-5 cursor-pointer text-primary focus:ring-primary"
        />
        <span className="text-sm font-medium text-gray-900">
          {formatMessage({
            id: 'createVisitFormV2.whenStep.endTime',
            defaultMessage: 'End time',
          })}
          {required && value === 'endTime' && <span className="text-destructive ml-1">*</span>}
        </span>
      </Label>
    </div>
  );
};
